export { default as RatingResume } from './RatingResume';
